import Sheet from 'components/utils/Sheet'
import React, { ComponentProps } from 'react'

type SheetProps = ComponentProps<typeof Sheet>
type InheritedSheetProps = Omit<SheetProps, 'background'>
type SheetBackground = SheetProps['background']

interface Props extends InheritedSheetProps {
  /**
   * @default neutral-eight
   */
  background?: SheetBackground
}

function Pane({ background = 'neutral-eight', ...rest }: Props) {
  return (
    <Sheet background={background} {...rest} />
  )
}

export default React.memo(Pane)
